import { useState, useEffect, useMemo } from 'react';

export function usePWAInstall() {
    const isRunningAsPWA = useMemo(() => {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
            (window.navigator.standalone === true) ||
            document.referrer.includes('android-app://');
        if (isStandalone) console.log('[iPlanner] PWA standalone mode');
        return isStandalone;
    }, []);

    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallPrompt, setShowInstallPrompt] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowInstallPrompt(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            setShowInstallPrompt(false);
        }
        setDeferredPrompt(null);
    };

    const dismissInstallPrompt = () => setShowInstallPrompt(false);

    return { isRunningAsPWA, showInstallPrompt, handleInstallClick, dismissInstallPrompt };
}
